import priceHtml from './price.html';

class PriceController {

    constructor($scope) {
        'ngInject';
    }

}

let priceComponent = {
    bindings: {
        'value': '<',
        'net': '<',
        'hideTaxText': '<',
        'showSimpleTaxText': '<',
        'currency': '<'
    },
    template: priceHtml,
    controller: PriceController
};

export default priceComponent;